import React from 'react';
import { Modal } from '@mui/material';

interface IHelpContentModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title?: string;
  description?: string;
  helpItems: { title: string; content: any; isDefaultOpen: boolean }[];
}
const HelpContentModal: React.FC<IHelpContentModalProps> = ({
  isOpen,
  setIsOpen,
  title = 'Help',
  description,
  helpItems = [],
}) => {
  return (
    <Modal open={isOpen} onClose={() => setIsOpen && setIsOpen(false)}>
      <div className='modal-right'>
        <div style={{ float: 'right' }}>
          <div
            className='classify-container-footer-clear-text'
            onClick={() => setIsOpen(false)}
            style={{ cursor: 'pointer' }}
          >
            X Close
          </div>
        </div>
        <div className='module-header-modal'>
          <div className='widget-header'>
            {title}
            {description && (
              <div
                className='widget-header-description'
                style={{ marginTop: '10px' }}
              >
                {description}
              </div>
            )}
          </div>
          {helpItems.map((item, index) => (
            <details key={index} open={item.isDefaultOpen}>
              <summary>{item.title}</summary>
              <div style={{ marginTop: 12 }}>{item.content}</div>
            </details>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default HelpContentModal;
